<template lang="pug">
    v-select(v-model="dateRangeSelect" :items="dateItems" return-object item-text="text" item-id="text" outlined dense solo hide-details)
</template>
<script>
import * as TimeHelper from "@/utils/timeHelper"

export default {
  mixins: [TimeHelper.mixin],
  props: {
    custom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rangeDateMenu: false,
      dateItems: [],
      dateRangeSelect: {},
      defaultItem: null
    }
  },
  watch: {
    dateRangeSelect(val) {
      this.$emit("input", val)
    },
    custom(val) {
      if (val) {
        this.dateRangeSelect = { text: this.$t("Reports.__Custom") }
      } else {
        this.dateRangeSelect = this.defaultItem
      }
    }
  },
  methods: {
    generateDateItems() {
      this.dateItems = []
      var today = new Date()
      var year = today.getFullYear()
      var month = today.getMonth()

      //year
      for (var i = 0; i < 3; i++) {
        var itemYear = year - i
        var item
        if (i == 0) {
          item = {
            text: itemYear.toString(),
            from: itemYear + "-01-01",
            to: this.getStringByFormat(today)
          }
          this.defaultItem = item
        } else {
          item = {
            text: itemYear.toString(),
            from: itemYear + "-01-01",
            to: itemYear + "-12-31"
          }
        }
        this.dateItems.push(item)
      }
      //Q1,Q2,Q3,Q4
      var q = Math.floor(month / 3 + 1)
      for (i = q; i > 0; i--) {
        this.dateItems.push(this.getQuarterItems(year, i))
      }
      itemYear = year - 1
      for (i = 4; i > 0; i--) {
        this.dateItems.push(this.getQuarterItems(itemYear, i))
      }
      //Month
      for (i = month + 1; i > 0; i--) {
        this.dateItems.push(this.getMonthItem(year, i))
      }
      itemYear = year - 1
      for (i = 12; i > 0; i--) {
        this.dateItems.push(this.getMonthItem(itemYear, i))
      }
      //Custom
      this.dateItems.push({ text: this.$t("Reports.__Custom") })
      this.dateRangeSelect = { text: this.$t("Reports.__Custom") }
    },
    getMonthItem(year, month) {
      var endDate = this.getStringByFormat(new Date(year, month, 0))
      var startDate = this.getStringByFormat(new Date(year, month - 1, 1))
      return {
        text: year + "-" + month.toString().padStart(2, "0"),
        from: startDate,
        to: endDate
      }
    },
    getQuarterItems(year, q) {
      switch (q) {
        case 1:
          return {
            text: year + " Q1",
            from: year + "-01-01",
            to: year + "-03-31"
          }
        case 2:
          return {
            text: year + " Q2",
            from: year + "-04-01",
            to: year + "-06-30"
          }
        case 3:
          return {
            text: year + " Q3",
            from: year + "-07-01",
            to: year + "-09-30"
          }
        case 4:
          return {
            text: year + " Q4",
            from: year + "-10-01",
            to: year + "-12-31"
          }
      }
    }
  },
  mounted() {
    this.generateDateItems()
  },
  created() {}
}
</script>
